<template>
  <div class="metting-upload-box">
    <UploadOss class="metting-upload" :drag="true" @onUploadProgress="onProgress" upload_type="cross">
      <div class="upload-box">
        <img src="image/img_upload_files.png" alt="">
        <p>点击或将文件拖拽到这里上传</p>
        <span>支持扩展名：.rar  .zip  .doc  .docx  .pdf  .jpg…</span>
      </div>
    </UploadOss>
    <div class="my-upload-list">
      <div class="upload-list---item" v-for="(file) in currentValue" :key="file.id || file.uid">
        <div class="upload-list---text">
          <!-- <img style="width:16px;height:16px;margin-right:14px;" :src="getIconType(file)" alt=""> -->
          <p>
            <span>
              {{(file.attachment_name).substr(0,getHeadText(file.attachment_name))}}
            </span>
            <span>{{(file.attachment_name).substr(getHeadText(file.attachment_name))}}</span>
          </p>
          <i class="my-upload-del icon iconfont iconicon_delete_annex activeIconHover" @click="removeFile(file)"></i>
        </div>
        <div class="el-progress-custom" v-if="file.percentage < 100">
          <el-progress :percentage="file.percentage" :show-text="false"></el-progress>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UploadOss from '@/components/uploadOss'
export default {
  props: ['value'],
  components: {
    UploadOss
  },
  data() {
    return {
      fileIcon: [
        {
          icon: 'image/icon/icon_mp4_annex.png',
          list: 'mp4,avi,flv,wav,mov,mpeg,dat,mpg'
        },
        {
          icon: 'image/icon/icon_doc_annex.png',
          list: 'doc,docx,text'
        }, {
          icon: 'image/icon/icon_gif_annex.png',
          list: 'gif'
        }, {
          icon: 'image/icon/icon_jpg_annex.png',
          list: 'jpg,jpe,png,bmp,svg'
        }, {
          icon: 'image/icon/icon_xls_annex.png',
          list: 'xls,xlsx'
        }, {
          icon: 'image/icon/icon_ppt_annex.png',
          list: 'ppt,pptx'
        }, {
          icon: 'image/icon/icon_pdf_annex.png',
          list: 'pdf'
        }
      ],
      fileList: []
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || [];
      },
      set: function (newValue) {
        this.$emit('input', newValue || [])
      }
    }
  },
  methods: {
    handleProgerss(event, file, fileList) {
      console.log(event, file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleDownload(file) {
      console.log(file);
    },
    handleRemove(file) {
      console.log('remove', mfile);
    },
    onError(err) {
      this.$message.error('上传失败或不支持该文件后缀')
    },
    onProgress(file) {
      let fl = this.currentValue.find((res) => res.name === file.name)
      if (fl) {
        fl = file
      } else {
        this.currentValue.push(file)
      }
    },
    getIconType(file) {
      let type = file.uid ? file.name.substr(file.name.lastIndexOf(".") + 1) : file.attachment_type
      let item = this.fileIcon.find(res => res.list.indexOf(type) > -1)
      return item ? item.icon : 'image/icon/icon_doc_annex.png'
    },
    removeFile(obj) {
      let id = obj.response ? obj.response.data.id : obj.id
      let idx = ''
      this.currentValue.find((res, index) => {
        if (res.response ? res.response.data.id == id : res.id === id) {
          idx = index
          return
        }
      })
      this.currentValue.splice(idx, 1)
    },
    getHeadText(data) {
      let idx = data.lastIndexOf(".") - 4
      return idx < 1 ? data.lastIndexOf(".") : idx
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/mixin';
.metting-upload-box {
  .metting-upload {
    text-align: center;
  }
  .upload-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    p {
      font-size: 14px;
      margin-top: 15px;
      margin-bottom: 18px;
    }
    span {
      font-size: 12px;
      color: rgba(32, 32, 40, 0.4);
    }
    img {
      width: 60px;
      height: 51px;
    }
  }
  .el-upload-dragger,
  .el-upload {
    width: 100%;
    height: 100%;
    background-color: rgba(241, 242, 243, 0.4);
  }
  .el-upload-dragger {
    border: 1px dashed rgba(32, 32, 40, 0.08);
    &:hover {
      border-color: $color-active;
    }
  }
  .el-upload {
    height: 204px;
  }
  .upload-demo {
    margin-top: 16px;
  }
  .el-upload-list__item-name {
    height: 48px;
    line-height: 48px;
    padding-left: 18px;
  }
  .el-upload-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .upload-list---item:nth-child(3n) {
    margin-right: 0;
  }
  .upload-list---item:first-child {
    margin-right: 11px;
  }
  .upload-list---item {
    margin-top: 10px;
    margin-right: 11px;
    padding-left: 18px;
    width: 432px;
    height: 72px;
    border: 1px solid rgba(32, 32, 40, 0.08);
    border-radius: 8px;
    position: relative;
    box-sizing: border-box;
    .my-upload-del {
      visibility: hidden;
    }
    &:hover {
      .my-upload-del {
        visibility: visible;
      }
    }
  }
  .my-upload-list {
    display: flex;
    flex-wrap: wrap;
  }
  .upload-list---text {
    display: flex;
    align-items: center;
    height: 100%;
    p {
      font-size: 14px;
      display: flex;
      span:first-child {
        max-width: 217px;
        @include ellipsis();
      }
    }
  }
  .my-upload-del {
    font-size: 14px;
    visibility: hidden;
    position: absolute;
    top: 50%;
    right: 18px;
    z-index: 1;
    transform: translate(0, -50%);
    cursor: pointer;
  }
  .el-progress-custom {
    width: 400px;
    margin-top: -15px;
    .el-progress-bar__outer {
      height: 4px !important;
    }
  }
  .el-upload-list__item .el-progress {
    top: 27px;
  }
}
</style>
